import {
  format,
  isToday,
  isTomorrow,
  startOfDay,
  differenceInDays,
} from "date-fns";

import { convertServerTimeToLocal } from "@whoosh/utilities/src/dates";

/**
 * Formats a signup deadline date string into a human-readable format
 * with smart countdown logic:
 *
 * - Same day → "today at 4:00 pm"
 * - Tomorrow → "tomorrow at 4:00 pm"
 * - More than 1 day away → "on Dec 18th at 4:00 pm"
 */
export const formatSignupDeadline = (dateString: string): string => {
  const localDate = convertServerTimeToLocal(dateString);
  const timeString = format(localDate, "h:mm aaa");

  if (isToday(localDate)) {
    return `today at ${timeString}`;
  }

  if (isTomorrow(localDate)) {
    return `tomorrow at ${timeString}`;
  }

  const daysUntil = differenceInDays(
    startOfDay(localDate),
    startOfDay(new Date())
  );

  if (daysUntil < 0) {
    // Date is in the past
    const dateFormatted = format(localDate, "MMM do");
    return `on ${dateFormatted} at ${timeString}`;
  }

  const dateFormatted = format(localDate, "MMM do");
  return `on ${dateFormatted} at ${timeString}`;
};
